// extracted by mini-css-extract-plugin
module.exports = {"heroBannerTextCenterWrapper":"HeroBannerShopContent_heroBannerTextCenterWrapper__TGmLa","titleImageContainer":"HeroBannerShopContent_titleImageContainer__qgY7R"};